import storeSlice from './storeSlice'
export default storeSlice
